"use client"

import MarkIcon from "@/components/icons/MarkIcon"
import SelectPlacement from "./SelectPlacement"
import FightDownIcon from "@/components/icons/FightDownIcon"
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks'
import { flightActions } from '@/lib/redux/features/flight/reduce'
import { FC, useEffect } from "react"
import { thunks } from "@/lib/redux/thunks"
import { getMetadataHotel } from "@/utils/hotel/getMetadataHotel"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { useTranslation } from "react-i18next"
import { useTETranslation } from "@/hooks/app/useTETranslation"

type SelectDestinationProps = {
  size?: 'small' | 'default',
  indexInputFlight: number
}

const SelectDestination: FC<SelectDestinationProps> = ({ size = 'default', indexInputFlight }) => {

  const searchingDestination = useAppSelector(state => state.hotel.searchingDestination)
  const location = useAppSelector(state => state.hotel.formSearch.location)
  const { t } = useTranslation()
  const { getTranslatedText } = useTETranslation()
  const dispatch = useAppDispatch()

  // useEffect(() => {
  //   dispatch(thunks.hotels_locations_search({
  //     params: {
  //       searchTerm: "",
  //       type: "INTERNAL",
  //       limit: 50,
  //       offset: 0
  //     }
  //   }))
  // }, [])

  return (
    <SelectPlacement
      size={size}
      value={location}
      label={t("hotel.to")}
      icon={<MarkIcon />}
      placeholder={t("hotel.to_placeholder")}
      onChange={(location) => {
        dispatch(hotelActions.selectDestination(location))
      }}
      onSearch={(val) => {
        if (!!val) {
          if (!searchingDestination) {
            dispatch(hotelActions.updateSearchingDate(true))
          }
        } else {
          if (searchingDestination) {
            dispatch(hotelActions.updateSearchingDate(false))
          }
        }
      }}
    />
  )
}

SelectDestination.displayName = 'SelectDestination'

export default SelectDestination